// importing react componet
import * as React from 'react';

// dev extreme grid component
import {
    SearchState,
    FilteringState,
    IntegratedFiltering,
    PagingState,
    SortingState,
    CustomPaging,
    IntegratedPaging,
    IntegratedSorting,
} from '@devexpress/dx-react-grid';

// dev extreme paper (like canvas for rendering grid)
import Paper from '@material-ui/core/Paper';

// dev extreme grid UI
import {
    Grid,
    Table,
    Toolbar,
    SearchPanel,
    TableHeaderRow,
    TableFilterRow,
    PagingPanel,
    TableColumnVisibility,
    ColumnChooser
} from '@devexpress/dx-react-grid-material-ui';

// importing api link 
import * as  apiService from '../../store/apiService';

// custom component
import TableCellwithColors from '../../sharedcomponents/TableCellwithColors';

// importing date format (mm/dd/yyyy)
import formatDate from '../../helpers/dateFormat';

// importing sorting helper
import { sortDatebySelection, sortNumber, sortCurrency, sortString } from '../../helpers/sortingHelper';

// Defining custom cell for Grid
// ts-ingore user for ignoring ts validation for perticular line

// enabling the functionality for display Header name when hover on column header 
// @ts-ignore
const ColumnHeaderCell = ({ getMessage, column, ...restProps }) => (
    // @ts-ignore
    <TableHeaderRow.Cell
        column={column}
        getMessage={() => column.title}
        {...restProps}
    />
);

// opening new tab in atlas with property number
function handleClickPropNum(args: any) {
    window.open(apiService.atlaslink(args), "_blank")
}



// providing custom UI design for required column
// @ts-ignore
const Cell = ({ value, ...restProps }) => {
    const { column } = restProps;
    if (column.name === 'deposit_received') {
        if (restProps.row.deposit_received === "Paid" || restProps.row.deposit_received === "Yes") {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.deposit_received === "Not Paid" || restProps.row.deposit_received === "No") {
            return <TableCellwithColors color="#d63636" />
        } else if (restProps.row.deposit_received === "N/A") {
            return <td><div>  </div></td>
        }
    }
    if (column.name === 'outfor_approval') {
        if (restProps.row[`date_needed`] !== "" &&
            restProps.row[`outfor_approval`] === "" &&
            restProps.row[`date_approved`] === "" &&
            restProps.row[`received`] === "0" &&
            (restProps.row[`completed`] === "0" || restProps.row[`completed`] === "")
        ) {
            return <TableCellwithColors color="#d63636" />
        }
        if (restProps.row[`date_needed`] !== "" &&
            restProps.row[`outfor_approval`] !== "" &&
            restProps.row[`date_approved`] === "" &&
            restProps.row[`received`] === "0" &&
            (restProps.row[`completed`] === "0" || restProps.row[`completed`] === "")
        ) {
            return <TableCellwithColors color="orange" />
        }
        if (restProps.row[`date_needed`] !== "" &&
            restProps.row[`outfor_approval`] !== "" &&
            restProps.row[`date_approved`] !== "" &&
            restProps.row[`received`] === "0" &&
            (restProps.row[`completed`] === "0" || restProps.row[`completed`] === "")
        ) {
            return <TableCellwithColors color="blue" />
        }
        if (restProps.row[`date_needed`] !== "" &&
            restProps.row[`outfor_approval`] !== "" &&
            restProps.row[`date_approved`] !== "" &&
            restProps.row[`received`] === "1" &&
            (restProps.row[`completed`] === "0" || restProps.row[`completed`] === "")
        ) {
            return <TableCellwithColors color="#00bb00" />
        }
    }
    if (column.name === 'date_needed') {
        return <td className="text-center"><div> {formatDate(restProps.row.date_needed)} </div></td>;
    } 
    if (column.name === 'cost') {
        if (restProps.row.cost === "") {
            return <td><div> $0.00 </div></td>;
        } else {
            return <td><div>${formatCost(restProps.row.cost)}</div></td>;
        }
    } 

    // adding link to property number in column
    if (column.name === 'prop_num') {
        return <td className="text-center">
            <div>
                <a style={{ color: 'lightblue' }} onClick={() => handleClickPropNum(restProps.row.prop_num)}>
                <i className="fa fa-trash-alt"></i>
                {restProps.row.prop_num}
                </a>
            </div>
        </td>
    }

    // @ts-ignore
    return <Table.Cell {...restProps} >
        <span title={value}>{value}</span>
    </Table.Cell>
};

// method for formating revenue in local string
const formatCost = (value: any) => {
    const tempnumber = value.toString().replace(/[!@#$%^&*]/g, "");
    return parseFloat(tempnumber).toLocaleString(undefined, { minimumFractionDigits: 2 })
}

const formatCostFilter = (value: any) => {
    const tempnumber = value.toString().replace(/[!@#$%^&*]/g, "");
    return parseFloat(tempnumber).toFixed(2)
}

// class
class EnclosurePOReportGrid extends React.Component<any, any> {
    public changeCurrentPage: any;
    public changePageSize: any;

    // initializing constructor
    constructor(props: any) {
        super(props);

        // initializing state
        this.state = {
            route: 'All',
            date: '',
            selectedReport: 'inProgress',
            selectedFilter: 'All',
            columns: [],
            rows: [],
            totalCount: 0,
            pageSizes: [10, 15, 30, 50],
            pageSize: 10,
            tableColumnExtensions: [
                { columnName: 'vendor', align: 'center' },
                { columnName: 'received', align: 'center' },
                { columnName: 'outfor_approval', align: 'center' },
                { columnName: 'salesperson', align: 'center' },
                { columnName: 'product', align: 'center' },
                { columnName: 'quantity', align: 'center' },
                { columnName: 'finish', align: 'left' },
                { columnName: 'date_needed', align: 'center' },
                { columnName: 'cost', align: 'center' },
                { columnName: 'ven_job_num', align: 'center' },
                { columnName: 'dsponum', align: 'center' }
            ],
            integratedSortingColumnExtensions: [
                { columnName: 'date_needed', compare: sortDatebySelection },
                { columnName: 'cost', compare: sortCurrency },
                { columnName: 'quantity', compare: sortNumber },
                { columnName: 'prop_num', compare: sortNumber },
                { columnName: 'client_reference', compare: sortString },
                { columnName: 'finish', compare: sortString },
                { columnName: 'product', compare: sortString },
            ],
            sorting : [{ columnName: 'prop_num', direction: 'asc' }],
            filteringColumnExtensions: [
                {
                    columnName: 'date_needed',
                    predicate: (value: any, filter: any, row: any) => {
                        if (filter.value) {
                            return this.filterDueDate(value, filter, row);
                        } else {
                            return true
                        }
                    },
                },
                {
                    columnName: 'cost',
                    predicate: (value: any, filter: any, row: any) => {
                        if (filter.value) {
                            if(filter.value === '$'){
                                return true;
                            } else {
                                return this.filterCost(value, filter, row);
                            }
                        } else  {
                            return true
                        }
                    },
                }
            ],
        };

        // binding public fuction to this
        this.changeCurrentPage = (currentPage: any) => this.setState({ currentPage });
        this.changePageSize = (pageSize: any) => this.setState({ pageSize });
    }

    public filterDueDate(value : any, filter : any, row : any) {
        return String(formatDate(row.date_needed)).indexOf(String(filter.value)) !== -1
    }

     public filterCost(value : any, filter : any, row : any) {
        return String(formatCostFilter(row.cost)).indexOf(String(formatCostFilter(filter.value))) !== -1
    }

    public render() {
        const {
            filteringColumnExtensions,
            currentPage,
            pageSize,
            sorting,
            integratedSortingColumnExtensions,
            tableColumnExtensions,
            totalCount,
            pageSizes
        } = this.state;
        return (
            <div>
                <Paper className="papergrid" style={{ position: 'relative' }}>
                    <Grid
                        rows={this.props.rows}
                        columns={this.props.columns}
                    >
                        <SearchState defaultValue="" />
                        <FilteringState 
                            columnExtensions={[
                                { columnName: 'deposit_received', filteringEnabled: false },
                                { columnName: 'outfor_approval', filteringEnabled: false }
                            ]}
                        />
                        <IntegratedFiltering columnExtensions={filteringColumnExtensions} />

                        <SortingState
                            defaultSorting={sorting}
                            columnExtensions={[
                                { columnName: 'deposit_received', sortingEnabled: false },
                                { columnName: 'outfor_approval', sortingEnabled: false } 
                            ]}
                        />
                        <IntegratedSorting
                            columnExtensions={integratedSortingColumnExtensions}
                        />
                        <PagingState
                            defaultCurrentPage={0}
                            currentPage={currentPage}
                            onCurrentPageChange={this.changeCurrentPage}
                            pageSize={pageSize}
                            onPageSizeChange={this.changePageSize}
                        />
                        <CustomPaging
                            totalCount={totalCount}
                        />
                        <IntegratedPaging />
                        <Table
                            columnExtensions={tableColumnExtensions}
                            cellComponent={Cell}
                        />
                        <TableHeaderRow
                            showSortingControls={true}
                            cellComponent={ColumnHeaderCell}
                        />
                        <TableFilterRow
                            showFilterSelector={false}
                        />
                        <TableColumnVisibility
                            defaultHiddenColumnNames={['']}
                        />
                        <Toolbar />
                        <SearchPanel />
                        <PagingPanel
                            pageSizes={pageSizes}
                        />
                        <ColumnChooser />
                    </Grid>
                </Paper>
            </div>
        );
    }
}
export default EnclosurePOReportGrid;



// WEBPACK FOOTER //
// ./src/components/Enclosure PO/enclosurePOReportGrid.tsx